import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';
import { useScreenSize } from '@banhala/ui-kit';
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
// shadow spec: x:0, y:2, blur:15, spread:0, #000000 10%
export const SHADOW_HEIGHT = 17;

export const TopGradientShadow: React.FC = () => {
  const { width } = useScreenSize();
  const size = useMemo(() => ({ width, height: SHADOW_HEIGHT }), [width]);
  return (
    <View style={styles.container} pointerEvents="none">
      <Svg
        width={size.width}
        height={size.height}
        viewBox={`0 0 ${size.width} ${size.height}`}
      >
        <Defs>
          <LinearGradient
            id="paint0_linear_top_shadow"
            x1={size.width * 0.5}
            y1="0"
            x2={size.width * 0.5}
            y2={size.height}
            gradientUnits="userSpaceOnUse"
          >
            <Stop offset="0" stopColor="#000000" stopOpacity="0" />
            <Stop offset="0.88" stopColor="#000000" stopOpacity="0.05" />
            <Stop offset="1" stopColor="#000000" stopOpacity="0.1" />
          </LinearGradient>
        </Defs>
        <Rect
          width={size.width}
          height={size.height}
          fill="url(#paint0_linear_top_shadow)"
        />
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: -SHADOW_HEIGHT,
    left: 0,
    right: 0,
  },
});
